'use client'

import React from 'react'
import { useSession } from 'next-auth/react'
import { usePathname } from 'next/navigation'
import NavContainer from '@/app/components/ui/navigation/navContainer'
import inter, { localInter } from '@styles/fonts'

export default function MainContent({ children }: { children: React.ReactNode }) {
	const { data: session } = useSession()
	const pathname = usePathname()

	const skipNav = pathname === '/feature/dashboard/compass-poc'

	return (
		<main className={`${inter.className} ${localInter.className}`}>
			{session?.user != null && !skipNav && <NavContainer>{children}</NavContainer>}
			{(session?.user == null || skipNav) && children}
		</main>
	)
}
